module.exports = __webpack_public_path__ + "static/media/Manual_de_usuario.7479e326.pdf";